<template style="background-color:white">
  <section class="init_box" style="background-color: white">
    <el-row type="flex" justify="end" style="flex-wrap: wrap; flex-direction: row">
      <el-col :span="24"
        style="margin-top: 15px;display: flex; flex-wrap: wrap; gap: 10px 0px; align-items: flex-start; align-content: flex-start;">
        <el-button class="btn" size="small" type="danger" style="margin-left: 10px;" v-if="btnRole.indexOf('130') != -1"
          @click="clickDeleteBtn">删除</el-button>
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('129') != -1"
          @click="toDeviceinAdd">添加</el-button>
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('131') != -1"
          @click="clickUpdateBtn">编辑</el-button>
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('189') != -1"
          @click="clickStartOrStop('start')">启用</el-button>
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('190') != -1"
          @click="clickStartOrStop('stop')">停用</el-button>
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('191') != -1"
          @click="clickDiaoBoOrUsed('diaoBo')">可调拨</el-button>
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('192') != -1"
          @click="clickDiaoBoOrUsed('used')">在用</el-button>
        <!-- <el-button
          class="btn"
          size="small"
          type="primary"
          @click="deviceCardClick"
          >设备卡片</el-button
        > -->
        <el-button class="btn" size="small" type="primary" @click="deviceCardsClick">设备卡片</el-button>
        <el-button class="btn" size="small" type="primary" @click="assetCardClick">资产卡片</el-button>
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('13') != -1"
          @click="clickWeiBao">申请维保</el-button>
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('19') != -1"
          @click="clickBaoFei">申请报废</el-button>
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('11') != -1"
          @click="clickCheck">检定录入</el-button>
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('132') != -1"
          @click="importExcelDialog = true">Excel导入</el-button>
        <el-button class="btn" size="small" type="primary" @click="export2Excel">导出台账</el-button>
        <el-button class="btn" size="small" type="primary" @click="exportAssetCard">导出资产卡片</el-button>
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('23') != -1"
          @click="clickDiaoBo">资产调拨</el-button>
        <!-- <el-button class="btn" type="warning" @click="">调出确认</el-button> -->
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('26') != -1"
          @click="clickDiaoBoQuer">调入确认</el-button>

        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('214') != -1"
          @click="transferToMarketHandle">划入设备超市</el-button>
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('222') != -1"
          @click="openChangeProjectDialog">变更项目</el-button>
        <el-button class="btn" size="small" type="primary" @click="toShare">分享</el-button>

        <!-- <el-button class="btn" size="small" type="primary" @click="selectDeviceCardClick">批量设备卡片</el-button>  -->

        <!-- <el-button class="btn" size="small" type="primary" @click="">打印设备卡片</el-button>
                <el-button class="btn" size="small" type="primary" @click="">打印资产卡片</el-button> -->
      </el-col>
    </el-row>
    <el-row style="margin-top: 15px; flex-wrap: wrap; flex-direction: row" type="flex" justify="end">
      <el-col :span="5" style="float: left; margin-top: 10px">
        <el-button type="primary" class="statueBtn" style="background-color: red"></el-button><span class="statueSpan"
          style="">调拨状态</span>
        <el-button type="primary" class="statueBtn" style="background-color: #580fda"></el-button><span
          class="statueSpan" style="">报废状态</span>
        <el-button type="primary" class="statueBtn" style="background-color: #d2b309"></el-button><span
          class="statueSpan" style="">检定/校准状态</span>
      </el-col>
      <!-- 搜索框 -->
      <el-col :span="19">
        <el-form :model="searchModel" :inline="true" style="float: right">
          <el-form-item label="使用部门">
            <el-cascader v-model="searchModel.company" style="width: 100%" :options="companySelect"
              :props="companyProps" clearable :show-all-levels="false" filterable placeholder="请选择单位"></el-cascader>
          </el-form-item>
          <el-form-item label="设备类型">
            <el-cascader v-model="searchModel.deviceType" style="width: 100%" clearable :options="deviceTypeSelect"
              :props="props" placeholder="请选择设备类型" :show-all-levels="false" filterable></el-cascader>
            <!-- <el-select v-model="searchModel.deviceType" filterable style="width: 100%;" placeholder="请选择设备类型"
                            class="input select">
                            <el-option v-for="items in deviceTypeSelect " :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select> -->
          </el-form-item>
          <el-form-item label="模糊搜索">
            <el-input placeholder="请输入查询厂家、编号、类型、名称" auto-complete="off" prefix-icon="el-icon-search"
              v-model="searchModel.search" style="width: 100%; margin-right: 55px" clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="录入日期">
            <el-date-picker
              v-model="searchModel.createTimeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 240px">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="" size="small" @click="searchDeviceinfo">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 筛选框按钮，可筛选显示的列 -->
      <el-col :span="24" style="float: left">
        <!-- <el-button style="float: right;margin-right: 15px;" icon="iconfont icon-liebiao"></el-button> -->
        <el-dropdown :hide-on-click="false" style="float: right; margin-right: 15px">
          <i class="iconfont icon-liebiao"></i>
          <el-dropdown-menu slot="dropdown">
            <el-scrollbar style="height: 60vh"><!--作用是数据过多把表单数据的整体高度固定、多出的区域可以下拉展示-->
              <el-checkbox-group v-model="check">
                <el-dropdown-item v-for="(item, index) in checkList" :key="index">
                  <el-checkbox :label="item" :key="item"> </el-checkbox>
                </el-dropdown-item>
              </el-checkbox-group>
            </el-scrollbar>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
      <!-- 数据展示表格 -->
      <el-col :span="24" style="margin-top: 5px">
        <el-table :data="deviceData" ref="deviceTable" id="deviceTable" @selection-change="changeCheckBoxValue"
          :header-cell-style="{ background: '#eff3f6' }" stripe :row-key="getRowKeys" style="
            width: 99%;
            margin: 0px auto;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          " height="600">
          <el-table-column fixed type="selection" width="55" :reserve-selection="true" style="border-color: black">
          </el-table-column>
          <el-table-column fixed type="index" label="序号" width="80">
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="item.prop == 'zcmc' && item.ispass" v-for="(item, index2) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index2" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip>
            <template slot-scope="scope" v-if="item.label == '资产名称'">
              <el-link :underline="false" v-if="scope.row.sbzt == '42'" style="color: red; text-decoration: none"
                @click="toDetail(scope.row)">
                {{ scope.row.zcmc }}
              </el-link>
              <el-link :underline="false" v-if="scope.row.sbzt == '4'" style="color: #580fda; text-decoration: none"
                @click="toDetail(scope.row)">
                {{ scope.row.zcmc }}
              </el-link>
              <el-link :underline="false" v-if="
                scope.row.sbzt == '41' ||
                scope.row.sbzt == '43' ||
                scope.row.sbzt == '44'
              " style="color: #d2b309; text-decoration: none" @click="toDetail(scope.row)">
                {{ scope.row.zcmc }}
              </el-link>
              <el-link :underline="false" v-if="
                scope.row.sbzt != '42' &&
                scope.row.sbzt != '4' &&
                scope.row.sbzt != '41' &&
                scope.row.sbzt != '43' &&
                scope.row.sbzt != '44'
              " style="color: #4095e5; text-decoration: none" @click="toDetail(scope.row)">
                {{ scope.row.zcmc }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column v-for="(item, index1) in deviceTable" v-if="item.prop == 'glbh' && item.ispass"
            :width="item.width" :prop="item.prop" :key="index1" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip :row-key="(row) => {
                return row.classId;
              }
              ">
            <template slot-scope="scope" v-if="item.prop == 'glbh'">
              <el-link :underline="false" v-if="scope.row.sbzt == '42'" style="color: red; text-decoration: none"
                @click="toDetail(scope.row)">
                {{ scope.row.glbh }}
              </el-link>
              <el-link :underline="false" v-if="scope.row.sbzt == '4'" style="color: #580fda; text-decoration: none"
                @click="toDetail(scope.row)">
                {{ scope.row.glbh }}
              </el-link>
              <el-link :underline="false" v-if="
                scope.row.sbzt == '41' ||
                scope.row.sbzt == '43' ||
                scope.row.sbzt == '44'
              " style="color: #d2b309; text-decoration: none" @click="toDetail(scope.row)">
                {{ scope.row.glbh }}
              </el-link>
              <el-link :underline="false" v-if="
                scope.row.sbzt != '42' &&
                scope.row.sbzt != '4' &&
                scope.row.sbzt != '41' &&
                scope.row.sbzt != '43' &&
                scope.row.sbzt != '44'
              " style="color: #4095e5; text-decoration: none" @click="toDetail(scope.row)">
                {{ scope.row.glbh }}
              </el-link>
            </template>
          </el-table-column>
          <!-- <el-table-column label="设备超市" align="center">
            <template slot-scope="scope">
              {{ scope.row.isMarket == "1" ? "是" : "否" }}
            </template>
          </el-table-column> -->
          <el-table-column v-if="item.prop == 'sbzt' && item.ispass" v-for="(item, index8) in deviceTable"
            align="center" :width="item.width" :prop="item.prop" :key="index8" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip>
            <template slot-scope="scope" v-if="item.prop == 'sbzt'">
              {{ scope.row.statusName }}
            </template>
          </el-table-column>
          <el-table-column width="100" label="使用年限/年" :formatter="formateUseTime" align="center">
          </el-table-column>
          <el-table-column v-if="item.prop == 'sydw' && item.ispass" v-for="(item, index3) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index3" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip>
            <template slot-scope="scope" v-if="item.prop == 'sydw'">
              {{ scope.row.companyname }}
            </template>
          </el-table-column>
          <el-table-column v-if="item.prop == 'yjfl' && item.ispass" v-for="(item, index4) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index4" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip :formatter="formateYjfl">
            <!-- <template slot-scope="scope" v-if="item.label == '一级分类'">
                            {{ formateYjfl(scope.row.yjfl) }}
                        </template> -->
          </el-table-column>
          <el-table-column v-if="item.prop == 'ejfl' && item.ispass" v-for="(item, index5) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index5" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip :formatter="formateEjfl">
            <!-- <template slot-scope="scope" v-if="item.label == '一级分类'">
                            {{ formateYjfl(scope.row.yjfl) }}
                        </template> -->
          </el-table-column>
          <el-table-column v-if="item.prop == 'zyfl' && item.ispass" v-for="(item, index6) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index6" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip :formatter="formateZyfl">
            <!-- <template slot-scope="scope" v-if="item.label == '一级分类'">
                            {{ formateYjfl(scope.row.yjfl) }}
                        </template> -->
          </el-table-column>
          <el-table-column v-if="item.prop == 'xmfl' && item.ispass" v-for="(item, index7) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index7" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip :formatter="formateXmfl">
            <!-- <template slot-scope="scope" v-if="item.label == '一级分类'">
                            {{ formateYjfl(scope.row.yjfl) }}
                        </template> -->
          </el-table-column>
          <el-table-column v-else-if="
            item.prop != 'glbh' &&
            item.prop != 'dbzt' &&
            item.prop != 'zcmc' &&
            item.prop != 'id' &&
            item.prop != 'sydw' &&
            item.prop != 'bz' &&
            item.prop != 'yjfl' &&
            item.prop != 'ejfl' &&
            item.prop != 'zyfl' &&
            item.prop != 'xmfl' &&
            item.prop != 'sbzt' &&
            item.ispass
          " :width="item.width" :prop="item.prop" :key="item.prop" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip>
          </el-table-column>

          <el-table-column v-if="item.prop == 'dbzt' && item.ispass" v-for="(item, index9) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index9" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip>
            <template slot-scope="scope" v-if="item.prop == 'dbzt'">
              <span v-if="scope.row.dbzt == 1">在用</span>
              <span v-if="scope.row.dbzt == 0">可调拨</span>
              <!-- {{scope.row.dbzt  }}  -->
            </template>
          </el-table-column>
          <el-table-column label="录入日期" width="120" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.lrrq ? scope.row.lrrq.substring(0, 10) : '--' }}
            </template>
          </el-table-column>
          <el-table-column v-if="item.prop == 'bz' && item.ispass" v-for="(item, index10) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index10" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip>
          </el-table-column>

          <!-- <el-table-column width="150" label="操作" >
                        <template  slot-scope="scope">
                           <el-switch v-model="scope.row.dbzt" active-text="在用" inactive-text="可调拨" @change="switchChange($event,scope.row)"></el-switch>
                        </template>
                    </el-table-column>-->
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination v-if="total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" :current-page="pageIndex"
          layout="total, sizes, prev, pager, next, jumper" :total="total" style="float: right">
        </el-pagination>
      </el-col>
    </el-row>
    <!-- 添加显示购物车按钮，如果复选框有选中让显示，否则不显示 -->
    <div style="
        position: fixed;
        top: 175px;
        left: 600px;
        height: 50px;
        width: 50px;
        font-size: 20px;
      " @click="checkBoxdialog = true" v-if="checkBoxData.length > 0">
      <!-- <i class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></i> -->
      <el-badge :value="checkBoxNumber">
        <!-- <span class="iconfont icon--task- " style="width:100%;height:100%;font-size: 40px"></span> -->
        <img src="../../../static/img/selects.png" style="width: 70%; height: 70%; font-size: 40px" />
      </el-badge>
    </div>
    <!-- 显示购物车列表 -->
    <el-dialog title="已选择设备" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="checkBoxdialog">
      <el-button type="primary" size="mini" @click="removeAllCheckbox"
        style="margin-top: -30px; float: left">清空内容</el-button>
      <el-table :data="checkBoxData" v-if="checkBoxNumber > 0" :header-cell-style="{ background: '#eff3f6' }"
        style="padding-top: 5px">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column property="zcmc" label="资产名称"></el-table-column>
        <el-table-column property="zcbh" label="资产编号"></el-table-column>
        <el-table-column property="glbh" label="管理编号"></el-table-column>
        <el-table-column property="sbxh" label="设备型号"></el-table-column>
        <el-table-column label="操作" style="text-decoration: none">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="removeThisData(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 办公设备卡片 -->
    <el-dialog title="办公设备卡片" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="deviceCarddialogbg" width="450px" @close="closeDialog">
      <!-- <deviceCardbg v-if="showType.indexOf('办公设备') != -1" ref="banGongCard" :deviceinfo="deviceDataDetail"
                style="margin-top:-30px;"></deviceCardbg> -->
      <device-cardbg v-if="showType.indexOf('办公设备') != -1" ref="banGongCard" :deviceinfo="deviceDataDetail"
        style="margin-top: -30px"></device-cardbg>
    </el-dialog>
    <!-- 检测设备卡片 -->
    <el-dialog title="检测设备卡片" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="deviceCarddialog" width="370px" @close="closeDialog">
      <DeviceinfoCard v-if="showType.indexOf('检测设备') != -1" ref="jianceCard" :deviceinfo="deviceDataDetail"
        style="margin-top:-30px;padding-left:50px'"></DeviceinfoCard>
    </el-dialog>
    <!------biu-->
    <!-- 批量办公设备卡片 -->
    <el-dialog title="办公设备卡片" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="deviceCarddialogbgPL" width="450px" @close="closeDialog">
      <deviceCardjcPL v-if="showType.indexOf('办公设备') != -1" ref="selectBanGongCard" :deviceinfo="deviceDataDetail"
        style="margin-top: -30px"></deviceCardjcPL>
    </el-dialog>
    <!-- 批量检测设备卡片 -->
    <el-dialog title="检测设备卡片" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="deviceCarddialogPL" width="370px" @close="closeDialog">
      <deviceinfoCardPL v-if="showType.indexOf('检测设备') != -1" ref="selectJianceCard" :deviceinfo="deviceDataDetail"
        style="margin-top:-30px;padding-left:50px'"></deviceinfoCardPL>
    </el-dialog>
    <!-- 资产卡片 -->
    <el-dialog title="资产卡片" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="assetCardDialog"
      width="70%">
      <div>
        <div height="60px">
          <el-button type="primary" v-print="printAccet" style="float: left">打印</el-button>
          <el-button type="primary" @click="downloadAssetCard" style="float: left; margin-right: 10px">下载</el-button>
        </div>
        <div id="printAsset" ref="printContent" style="min-height: 140px">
          <div ref="docxView" id="assetDiv"></div>
        </div>
      </div>
    </el-dialog>
    <!-- 申请维保、申请报废、检定录入、资产调拨、调入确认 -->
    <el-dialog :title="dialogTitle" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="dialogShow" width="35%" @close="closeDialog">
      <!-- 点击维保申请按钮显示 -->
      <WeibaoApplyVue v-if="showType.indexOf('维保') != -1" ref="weibaoApply" :deviceinfo="checkBoxData" @func="isShow"
        @select="getDeviceinfo"></WeibaoApplyVue>
      <!-- 点击申请报废按钮显示 -->
      <baoFeiApplyVue v-if="showType.indexOf('报废') != -1" ref="baoFeiApply" :deviceinfo="checkBoxData" @func="isShow"
        @select="getDeviceinfo"></baoFeiApplyVue>
      <!-- 点击检定录入按钮显示 -->
      <!-- 点击资产调拨按钮显示 -->
      <!-- 点击调入确认按钮显示 -->
    </el-dialog>
    <!-- Excel导入 -->
    <el-dialog title="excel导入" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="importExcelDialog" width="350px" @close="closeExcelDialog">
      <el-form ref="excelForm" :model="excelForm" label-width="80px">
        <el-form-item label="导入设备" prop="deviceExcel" :rules="{ required: true }">
          <!-- <el-upload class="upload-demo" action="" :before-upload="beforeUpload"
						:show-file-list="false" :http-request="uploadFile"> -->
          <el-upload class="upload-demo" action="string" style="align: left" :on-preview="handlePreview"
            :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1" :on-exceed="handleExceed"
            :file-list="fileList" :auto-upload="false" :http-request="uploadFile" :on-change="handleChange"
            :before-upload="beforeUpload" accept=".xlsx">
            <el-button size="mini" type="info" plain :loading="uploadBool">
              {{ uploadBool ? "文件上传中..." : "导入设备" }}
            </el-button>
          </el-upload>
          <!-- <imgUpload type="2" :limit="1" @fileListChange="fileListChange"/> -->
          <div class="upload__tips">仅支持上传.xlsx文件</div>
          <el-button type="text" @click="download">下载设备导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickUpload" v-if="excelLoading == false">上传文件</el-button>
          <el-button type="primary" v-if="excelLoading == true">上传中……</el-button>
          <el-button @click="importExcelDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!----------划入设备超市----------->
    <el-dialog :visible.sync="toMarketShow" title="划入设备超市" :close-on-click-modal="false" :close-on-press-escape="false"
      width="1000px">
      <el-form :model="toMarketForm" ref="toMarketForm" :rules="toMarketRules" label-position="left"
        label-width="100px">
        <el-row>
          <el-col :span="8" align="left">
            <el-form-item label="保管人" prop="personName">
              <el-autocomplete v-model.trim="toMarketForm.personName" :fetch-suggestions="queryPersonHistory"
                placeholder="请输入保管人" clearable @select="handlePersonSelect" :trigger-on-focus="true"
                :highlight-first-item="true" style="width: 100%" value-key="value" :debounce="300">
                <template slot-scope="{ item }">
                  <div class="person-history-item">
                    <i class="el-icon-user"></i>
                    <span>{{ item.value }}</span>
                  </div>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" align="left">
            <el-form-item label="所在货架" prop="shelvesIds">
              <el-cascader style="width: 100%" ref="cascader" v-model="toMarketForm.shelvesIds" :props="shelvesProps"
                @change="handleCascaderChange" placeholder="选择所在货架" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" align="left" style="padding-bottom: 10px">
            附件清单：
          </el-col>
          <el-col :span="24" align="left" v-if="annexList.length > 0">
            <el-table :data="annexList" size="small" style="width: 100%">
              <el-table-column prop="zcmc" label="名称" align="left">
              </el-table-column>
              <el-table-column prop="glbh" label="管理编号"> </el-table-column>
              <el-table-column prop="ccbh" label="出厂编号"> </el-table-column>
              <el-table-column prop="cgrq" label="采购日期"> </el-table-column>
              <el-table-column prop="clfw" label="测量范围"> </el-table-column>
              <el-table-column prop="cljd" label="测量精度"> </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" align="left" v-else> 该设备无附件 </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="toMarketShow = false">取 消</el-button>
        <el-button type="primary" @click="transferToMarketOk" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showCards" title="导出设备卡片" :close-on-click-modal="false" :close-on-press-escape="false"
      width="600px">
      <div>
        <iframe :src="'/sysbgl/pdfjs/web/viewer.html?file=' +
          encodeURIComponent(
            '/sbgl_api/deviceinfo/cards.pdf?ids=' + exportIds
          )
          " width="560" height="500">
        </iframe>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="showCards = false">关闭</el-button>
        </div>
      </template>
    </el-dialog>

    <!----------分享----------->
    <el-dialog :visible.sync="shareShow" title="分享" :close-on-click-modal="false" :close-on-press-escape="false"
      width="1000px">
      <div style="margin: 20px; padding-bottom: 50px; color: #000">
        <div>
          <span style="width: 300px; display: inline-block">
            分享人：{{ shareMan }}
          </span>
          <span style="width: 300px; display: inline-block">当前使用部门：{{ shareDept ? shareDept : "未选择" }}</span>
        </div>
        <div style="line-height: 40px; display: flex; align-items: center;">
          <span>{{ shareUrl }}</span>
          <el-button size="mini" type="primary" style="margin-left: 10px;" @click="copyShareUrl">复制</el-button>
        </div>
        <div style="line-height: 40px">网址有效期为5分钟，请尽快使用</div>
      </div>
    </el-dialog>

    <!----------变更项目----------->
    <el-dialog :visible.sync="changeProjectDialog" title="变更项目" :close-on-click-modal="false" 
      :close-on-press-escape="false" width="600px">
      <el-form :model="changeProjectForm" label-width="120px" style="margin: 20px">
        <el-form-item label="设备名称">
          <el-input v-model="changeProjectForm.deviceName" disabled></el-input>
        </el-form-item>
        <el-form-item label="管理编号">
          <el-input v-model="changeProjectForm.manageCode" disabled></el-input>
        </el-form-item>
        <el-form-item label="原使用部门">
          <el-input v-model="changeProjectForm.oldDeptName" disabled></el-input>
        </el-form-item>
        <el-form-item label="新使用部门" required>
          <el-cascader v-model="changeProjectForm.newDeptCode" style="width: 100%" :options="companySelect"
            :props="companyProps" clearable :show-all-levels="false" filterable placeholder="请选择新使用部门"></el-cascader>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="changeProjectDialog = false">取消</el-button>
          <el-button type="info" icon="el-icon-time" @click="openChangeHistoryDialog">变更记录</el-button>
          <el-button type="primary" @click="submitChangeProject" :loading="changeProjectLoading">确定</el-button>
        </div>
      </template>
    </el-dialog>

    <!----------变更记录----------->
    <el-dialog :visible.sync="changeHistoryDialog" title="设备部门变更记录" 
      :close-on-click-modal="false" :close-on-press-escape="false" width="1000px">
      <el-table :data="changeHistoryList" v-loading="changeHistoryLoading" 
        :header-cell-style="{ background: '#eff3f6' }" stripe height="400">
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="oldDeptName" label="原使用部门" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="newDeptName" label="新使用部门" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="operatorName" label="操作人" width="100" align="center"></el-table-column>
        <el-table-column prop="changeTime" label="变更时间" width="160" align="center">
          <template slot-scope="scope">
            {{ scope.row.changeTime | formatDate }}
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="changeHistoryDialog = false">关闭</el-button>
        </div>
      </template>
    </el-dialog>
  </section>
</template>
<script>
// 日期格式化过滤器
const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

import DeviceinfoCard from "./Deviceinfo_card.vue";
import deviceinfoCardPL from "./Deviceinfo_cardPL.vue";

// import AssetCard from './components/AssetCard.vue';

import {
  assetCard,
  insertDevices,
  selectAllDeviceinfo,
  selectAllCompany,
  selectAllLable,
  deleteDeviceinfoByid,
  treeCompanyByCode,
  selectAllMajorType,
  selectAllProjectType,
  getStatueByDevice,
  selectTreeDeviceType,
  selectAllProjectTypeByMid,
  usedOrDiaoBo,
  getShareString,
  selectAllDeviceType,
  startOrStop,
  getBase,
  exportDevice,
  exportAssetCard,
  getTreeDeviceType,
  findByUserIdCompanyTree,
  transferToMarket,
  selectShelves,
  selectAnnex,
  changeDeviceProject,
  getDeviceDeptChangeHistory,
} from "../../api/api";
import WeibaoApplyVue from "../../components/common/WeibaoApply.vue";
import baoFeiApplyVue from "../../components/common/BaoFeiApply.vue";
import DeviceCardbg from "./deviceCardbg.vue";
const docxPre = require("docx-preview");
window.JSZip = require("jszip");
export default {
  name: "Deviceinfo",
  components: {
    DeviceinfoCard,
    WeibaoApplyVue,
    baoFeiApplyVue,
    DeviceCardbg,
    deviceinfoCardPL,
  },
  filters: {
    formatDate
  },
  data() {
    return {
      props: {
        label: "deviceTypeName",
        value: "id",
        children: "deviceTypes",
        expandTrigger: "click",
        emitPath: false,
        checkStrictly: true, //设置可以单选一级
      },
      shelvesProps: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { value } = node;
          let nodes = [];
          selectShelves({ pid: value ? value : 0 }).then((datas) => {
            let { status, data } = datas;
            if (status == 200) {
              data.forEach((item) => {
                nodes.push({
                  label: item.name,
                  value: item.id,
                  leaf: item.deep == 3 ? true : false,
                });
              });
            }
            resolve(nodes);
          });
        },
      },
      companyProps: {
        checkStrictly: true,
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
        emitPath: false,
      },
      excelForm: {
        deviceExcel: "",
      },
      checkBoxNumber: 0,
      deviceCarddialog: false,
      deviceCarddialogbg: false,
      deviceCarddialogPL: false,
      deviceCarddialogbgPL: false,
      checkBoxdialog: false,
      importExcelDialog: false,
      checked: false,
      assetCardDialog: false,
      check: [],
      checkList: [],
      fileList: [],
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      deviceData: [],
      deviceDataDetail: [],
      deviceTable: [],
      searchModel: {
        search: "",
        deviceType: "",
        company: "",
        createTimeRange: [],
      },
      deviceTypeSelect: [],
      companyData: [],
      companySelect: [],
      deviceTotalData: [],
      checkBoxData: [],
      deviceTypeData: [],
      xmflData: [],
      zyflData: [],
      deviceStatuData: [],
      btnRole: [],
      printObj: {
        id: "print", //id
        popTitle: "设备管理卡片", //自定义设置标题
        style: "margin-top:20px",
      },
      printAccet: {
        id: "printAsset", //id
        popTitle: "资产卡片", //自定义设置标题
        style: "margin-top:20px",
      },
      deviceinfoData: [],
      dialogTitle: "",
      dialogShow: false,
      showType: "",
      // 上传中
      uploadBool: false,
      deviceinfoList: [],
      excelLoading: false,
      excelLoadingText: "立即上传",
      yjid: "",
      zyid: "",
      xmid: "",
      loading: false,
      loadingText: "",
      loadingInstance: null,
      //划入设备超市
      toMarketShow: false,
      toMarketForm: {},
      toMarketRules: {
        personName: [
          { required: true, message: "请输入保管人", trigger: "blur" },
        ],
        shelvesIds: [
          { required: true, message: "请选择货架", trigger: "blur" },
        ],
      },
      annexList: [],
      showCards: false,
      exportIds: "",
      shareShow: false,
      shareString: "",
      shareUrl: "",
      shareMan: "",
      shareDept: "",
      // 变更项目
      changeProjectDialog: false,
      changeProjectLoading: false,
      changeProjectForm: {
        deviceId: '',
        deviceName: '',
        manageCode: '',
        oldDeptCode: '',
        oldDeptName: '',
        newDeptCode: '',
        newDeptName: ''
      },
      // 变更记录
      changeHistoryDialog: false,
      changeHistoryList: [],
      changeHistoryLoading: false,
      // 保管人历史记录
      personHistory: [],
      maxPersonHistoryLength: 20, // 最大存储数量
    };
  },
  methods: {
    // 单元格样式
    tableCellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#b7e0ff;padding:0px;border-color: #000000;border-top:#000000; ";
      }

      if (rowIndex === 3) {
        return "padding:0px;border-color: #000000;border-top:#000000";
      }
      return "border-color: #000000;padding:1px;border-left:#000000";
    },
    //隐藏地址选择下拉
    handleCascaderChange() {
      this.$refs.cascader.dropDownVisible = false;
    },
    // 合并单元格
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        if (columnIndex === 0) {
          return {
            rowspan: 1,
            colspan: 4,
          };
          // return [1, 4];
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      if (rowIndex === 1) {
        if (columnIndex === 1) {
          return {
            rowspan: 1,
            colspan: 4,
          };
        } else if (columnIndex != 1 && columnIndex != 0) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      if (
        rowIndex === 2 ||
        rowIndex === 3 ||
        rowIndex === 4 ||
        rowIndex === 5 ||
        rowIndex === 6
      ) {
        if (columnIndex === 1) {
          return {
            rowspan: 1,
            colspan: 2,
          };
        } else if (columnIndex != 0 && columnIndex != 2) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      if (columnIndex === 2) {
        if (rowIndex === 2) {
          return {
            rowspan: 5,
            colspan: 1,
          };
        } else if (rowIndex != 7) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    getRowKeys(row) {
      return row.id;
    },
    toShare() {
      this.loadingUtil.showLoading("请稍后……");
      let userinfo = JSON.parse(localStorage.getItem("user"));
      this.shareMan = userinfo.userName;
      let _this = this;
      getShareString({ sydw: this.searchModel.company }).then((datas) => {
        let { status, message, data } = datas;
        _this.loadingUtil.hideLoading();
        if (status != 200) {
          this.$message.warning(message || "分享失败");
          return;
        }
        this.shareString = data.shareString;
        this.shareUrl = window.location.origin + getBase() + "/deviceinfo/deviceinfoOut/" + data.shareString;
        this.shareDept = data.company;
        this.shareShow = true;
      });
    },
    // 复制分享链接
    copyShareUrl() {
      const text = this.shareUrl;
      if (!text) {
        this.$message.warning("暂无分享链接");
        return;
      }
      // 优先使用现代 Clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success("复制成功");
        }).catch(() => {
          this.fallbackCopy(text);
        });
      } else {
        this.fallbackCopy(text);
      }
    },
    // 兼容旧浏览器的复制方式
    fallbackCopy(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        this.$message.success("复制成功");
      } catch (e) {
        this.$message.error("复制失败，请手动复制");
      }
      document.body.removeChild(textarea);
    },
    // 打开变更项目对话框
    openChangeProjectDialog() {
      // 检查是否选中了设备
      if (this.checkBoxData.length === 0) {
        this.$message.warning('请先选择要变更的设备');
        return;
      }
      if (this.checkBoxData.length > 1) {
        this.$message.warning('一次只能选择一个设备进行变更');
        return;
      }
      
      const device = this.checkBoxData[0];
      console.log('选中的设备数据:', device); // 调试用，查看实际字段
      
      this.changeProjectForm = {
        deviceId: device.id,
        deviceName: device.zcmc || device.deviceName || '',  // 资产名称/设备名称
        manageCode: device.glbh || device.manageCode || '',  // 管理编号
        oldDeptCode: device.sydw || '',  // 使用单位编码
        oldDeptName: device.companyname || device.companyName || '',  // 使用部门名称
        newDeptCode: '',
        newDeptName: ''
      };
      
      console.log('表单数据:', this.changeProjectForm); // 调试用
      this.changeProjectDialog = true;
    },
    // 提交变更项目
    submitChangeProject() {
      if (!this.changeProjectForm.newDeptCode) {
        this.$message.warning('请选择新使用部门');
        return;
      }
      
      // 获取新部门名称
      const findDeptName = (code, options) => {
        for (let item of options) {
          if (item.companyCode === code) {
            return item.companyName;
          }
          if (item.zcompany && item.zcompany.length > 0) {
            const found = findDeptName(code, item.zcompany);
            if (found) return found;
          }
        }
        return '';
      };
      
      this.changeProjectForm.newDeptName = findDeptName(this.changeProjectForm.newDeptCode, this.companySelect);
      
      // 获取当前用户ID
      let userId = '';
      try {
        const userStr = localStorage.getItem('user');
        if (userStr) {
          userId = JSON.parse(userStr).userId || '';
        }
      } catch (e) {
        console.error('解析用户信息失败:', e);
      }
      
      this.changeProjectLoading = true;
      const params = {
        ...this.changeProjectForm,
        userId: userId
      };
      changeDeviceProject(params).then((res) => {
        this.changeProjectLoading = false;
        if (res.status === 200) {
          this.$message.success('变更项目成功');
          this.changeProjectDialog = false;
          // 刷新列表（_doGetDeviceinfo会自动同步checkBoxData）
          this.getDeviceinfo();
        } else {
          this.$message.error(res.message || '变更项目失败');
        }
      }).catch((err) => {
        this.changeProjectLoading = false;
        this.$message.error('网络错误，请重试');
        console.error('变更项目错误:', err);
      });
    },
    // 打开变更记录对话框
    openChangeHistoryDialog() {
      if (!this.changeProjectForm.deviceId) {
        this.$message.warning('请先选择设备');
        return;
      }
      
      this.changeHistoryDialog = true;
      this.loadChangeHistory();
    },
    // 加载变更历史
    loadChangeHistory() {
      this.changeHistoryLoading = true;
      getDeviceDeptChangeHistory({ deviceId: this.changeProjectForm.deviceId })
        .then((res) => {
          this.changeHistoryLoading = false;
          if (res.status === 200) {
            this.changeHistoryList = res.data || [];
            if (this.changeHistoryList.length === 0) {
              this.$message.info('暂无变更记录');
            }
          } else {
            this.$message.error(res.message || '查询失败');
          }
        })
        .catch((err) => {
          this.changeHistoryLoading = false;
          this.$message.error('网络错误，请重试');
          console.error('查询变更历史错误:', err);
        });
    },
    // 保管人历史记录管理
    // 保存保管人历史到本地存储
    savePersonHistory(personName) {
      if (!personName || personName.trim() === '') {
        return;
      }

      const trimmedName = personName.trim();

      // 移除重复的记录
      this.personHistory = this.personHistory.filter(item => item !== trimmedName);

      // 在数组开头添加新的记录
      this.personHistory.unshift(trimmedName);

      // 限制历史记录数量
      if (this.personHistory.length > this.maxPersonHistoryLength) {
        this.personHistory = this.personHistory.slice(0, this.maxPersonHistoryLength);
      }

      // 保存到本地存储
      localStorage.setItem('devicePersonHistory', JSON.stringify(this.personHistory));
    },

    // 从本地存储加载保管人历史
    loadPersonHistory() {
      try {
        const history = localStorage.getItem('devicePersonHistory');
        if (history) {
          this.personHistory = JSON.parse(history);
          console.log('加载保管人历史成功:', this.personHistory);
        } else {
          console.log('未找到保管人历史，初始化测试数据');
          // 初始化一些测试数据
          this.personHistory = [];
          localStorage.setItem('devicePersonHistory', JSON.stringify(this.personHistory));
        }
      } catch (error) {
        console.error('加载保管人历史失败:', error);
        this.personHistory = []; // 备用测试数据
      }
    },

    // 保管人自动完成查询函数
    queryPersonHistory(queryString, callback) {
      console.log('查询保管人历史:', queryString, '当前历史:', this.personHistory);

      let results = [];

      if (queryString) {
        // 有输入内容时，过滤匹配的历史记录
        results = this.personHistory
          .filter(item => {
            return item.toLowerCase().indexOf(queryString.toLowerCase()) !== -1;
          })
          .map(item => {
            return { value: item };
          });
      } else {
        // 无输入内容时，显示所有历史记录
        results = this.personHistory.map(item => ({ value: item }));
      }

      // 限制显示数量，最多10条
      results = results.slice(0, 10);

      console.log('返回结果:', results);

      // 直接调用回调
      callback(results);
    },

    // 处理保管人历史记录选择
    handlePersonSelect(item) {
      this.toMarketForm.personName = item.value;
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      sessionStorage.setItem("pageIndex", val);
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.getDeviceinfo();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getDeviceinfo();
    },
    //获取label不为id的label加在checkList里面
    getCheckList() {
      // debugger
      for (var i = 0; i < this.deviceTable.length; i++) {
        let id = "id";
        if (this.deviceTable[i].label.indexOf(id) < 0) {
          this.checkList.push(this.deviceTable[i].label);
        }
      }
    },
    //获取ispass为true的加载check里面
    getCheck() {
      for (var i = 0; i < this.deviceTable.length; i++) {
        // debugger
        let id = "id";
        if (this.deviceTable[i].label.indexOf(id) < 0) {
          if (this.deviceTable[i].ispass.indexOf("true") >= 0) {
            // debugger
            this.check.push(this.deviceTable[i].label);
          }
        }
      }
    },
    //查询所有label
    selectAllLables() {
      selectAllLable().then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          sessionStorage.setItem("deviceinfoLable", JSON.stringify(data));
          // debugger
          for (var i = 0; i < data.length; i++) {
            if (
              data[i].showPostion == 1 ||
              data[i].showPostion == 4 ||
              data[i].showPostion == 5
            ) {
              this.deviceTable.push(data[i]);
            }
          }
          this.getCheckList();
          this.getCheck();
          // 动态列在表格挂载后插入，需手动触发表格重新计算列宽
          this.$nextTick(() => {
            if (this.$refs.deviceTable) {
              this.$refs.deviceTable.doLayout();
            }
          });
        } else {
          this.recoverDeviceTableFromCache();
        }
      }).catch(() => {
        this.recoverDeviceTableFromCache();
      });
      const userStr = localStorage.getItem("user");
      if (userStr) {
        try {
          let userinfo = JSON.parse(userStr);
          if (userinfo && userinfo.role && userinfo.role.menuId) {
            this.btnRole = userinfo.role.menuId.split(",");
          }
        } catch (e) {
          // ignore parse error
        }
      }
    },
    // 列配置加载失败时，从 sessionStorage 缓存恢复，避免表格只剩固定列
    recoverDeviceTableFromCache() {
      if (this.deviceTable.length > 0) {
        return;
      }
      try {
        const cache = sessionStorage.getItem("deviceinfoLable");
        if (cache) {
          const data = JSON.parse(cache);
          for (var i = 0; i < data.length; i++) {
            if (
              data[i].showPostion == 1 ||
              data[i].showPostion == 4 ||
              data[i].showPostion == 5
            ) {
              this.deviceTable.push(data[i]);
            }
          }
          this.getCheckList();
          this.getCheck();
        }
      } catch (e) {
        // ignore parse error
      }
      if (this.deviceTable.length > 0) {
        this.$message.warning("列配置加载失败，已使用缓存，建议刷新页面");
      } else {
        this.$message.error("列配置加载失败，请刷新页面重试");
      }
      this.$nextTick(() => {
        if (this.$refs.deviceTable) {
          this.$refs.deviceTable.doLayout();
        }
      });
    },
    getCompanyTree() {
      const userStr = localStorage.getItem("user");
      if (!userStr) return;
      var userinfo = JSON.parse(userStr);
      var companyCode = "";
      if (
        userinfo.userRole == 1 ||
        (userinfo.fjqx != null &&
          (userinfo.fjqx.indexOf("3") != -1 ||
            userinfo.fjqx.indexOf("4") != -1))
      ) {
        companyCode = "-1";
      } else {
        companyCode = userinfo.companyCode;
      }
      findByUserIdCompanyTree(companyCode).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.companySelect = this.getCompanyTreeData(data);
        }
      });
    },

    getCompanyTreeData(companyData) {
      for (let i = 0; i < companyData.length; i++) {
        if (companyData[i].zcompany.length > 0) {
          // children不为空时继续调用该方法
          this.getCompanyTreeData(companyData[i].zcompany);
        } else {
          // 最后一级没有数据将children变成undefined
          companyData[i].zcompany = undefined;
        }
      }
      return companyData;
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].deviceTypes.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].deviceTypes = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].deviceTypes);
        }
      }
      return data;
    },
    //查询所有分类数据
    getfenleiData() {
      //查找设备状态
      let _this = this;
      getStatueByDevice().then((datas) => {
        let { status, data } = datas;

        if (status == 200) {
          // this.deviceStatuData=data
          for (var i = 0; i < data.length; i++) {
            // if (data[i].statusName.indexOf('待审核') == -1) {
            _this.deviceStatuData.push(data[i]);
            // }
          }

          sessionStorage.setItem(
            "deviceStatuData",
            JSON.stringify(_this.deviceStatuData)
          );
        }
      });
      selectAllCompany().then((resultData) => {
        let { status, data } = resultData;
        if (status == 200) {
          this.companyData = data;
        }
      });
      // //查找单位
      // selectAllCompany().then(datas => {
      //     let { status, data } = datas
      //     if (status == 200) {
      //         for (var i = 0; i < data.length; i++) {

      //         }

      //     }
      // })
      // 查找设备类型

      selectAllDeviceType().then((datas) => {
        let { status, data } = datas;
        if (status == 200) {
          sessionStorage.setItem("deviceTypeData", JSON.stringify(data));
          this.deviceTypeData = data;
          // this.deviceTypeSelect.push({ label: "所有设备", value: "所有设备" })
          // for (var i = 0; i < data.length; i++) {
          //     if (data[i].pid != "P") {
          //         this.deviceTypeSelect.push({ label: data[i].deviceTypeName, value: data[i].deviceTypeCode + "-" + data[i].pid })
          //     }
          // }
        }
      });

      const userStr = localStorage.getItem("user");
      if (!userStr) return;
      let _parmas = {
        userId: JSON.parse(userStr).userId,
      };

      getTreeDeviceType(_parmas).then((datas) => {
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          _this.deviceTypeSelect = this.getTreeData(data);
          // debugger
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      });
      //查找专业
      selectAllMajorType().then((datas) => {
        let { status, data } = datas;
        if (status == 200) {
          this.zyflData = data;
          sessionStorage.setItem("zyflData", JSON.stringify(data));
        }
      });

      selectAllProjectType().then((datas) => {
        let { status, data } = datas;
        if (status == 200) {
          this.xmflData = data;
          sessionStorage.setItem("xmflData", JSON.stringify(data));
        }
      });
    },
    // 加载设备数据（带 session 未就绪重试机制）
    loadDeviceData() {
      // 首次进入页面时，token 存在但 session 可能还未同步到后端，
      // 延迟一小段时间再请求，避免后端返回 401
      var token = localStorage.getItem('token');
      var delay = token ? 300 : 0;
      setTimeout(() => {
        this.getDeviceinfo();
      }, delay);
    },
    //查找设备信息
    getDeviceinfo() {
      if (
        sessionStorage.getItem("update") == "true" ||
        sessionStorage.getItem("detail") == "true"
      ) {
        if (sessionStorage.getItem("pageIndex") != undefined) {
          this.pageIndex = sessionStorage.getItem("pageIndex") * 1;
          if (sessionStorage.getItem("detail") == "true") {
            sessionStorage.setItem("detail", false);
          }
          if (sessionStorage.getItem("update") == "true") {
            sessionStorage.setItem("update", false);
          }
        }
      }
      let userId = "";
      try {
        const userStr = localStorage.getItem("user");
        if (userStr) {
          userId = JSON.parse(userStr).userId || "";
        }
      } catch (e) {
        console.error("解析用户信息失败:", e);
      }
      let _params = {
        content: this.searchModel.search,
        ejfl: this.searchModel.deviceType,
        pageIndex: this.pageIndex,
        pageSize: this.pagesize,
        sydw: this.searchModel.company,
        userId: userId,
        createTimeStart: this.searchModel.createTimeRange ? this.searchModel.createTimeRange[0] : '',
        createTimeEnd: this.searchModel.createTimeRange ? this.searchModel.createTimeRange[1] : '',
      };
      this._doGetDeviceinfo(_params);
    },
    _doGetDeviceinfo(_params) {
      selectAllDeviceinfo(_params).then((datas) => {
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          this.deviceData = data.list;
          this.total = data.total;
          // 同步更新checkBoxData，确保选中行数据是最新的
          if (this.checkBoxData.length > 0) {
            this.checkBoxData = this.checkBoxData.map(checked => {
              const updated = this.deviceData.find(d => d.id === checked.id);
              return updated || checked;
            });
          }
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      }).catch((error) => {
        // 如果是 session 未就绪错误，延迟 1 秒后重试一次
        if (error && error.message === 'SESSION_NOT_READY') {
          console.warn('Session 未就绪，1秒后重试加载设备列表');
          setTimeout(() => {
            this._doGetDeviceinfo(_params);
          }, 1000);
          return;
        }
        console.error("获取设备列表失败:", error);
      });
    },
    //模糊搜索查找设备信息
    searchDeviceinfo() {
      if (
        sessionStorage.getItem("update") == "true" ||
        sessionStorage.getItem("detail") == "true"
      ) {
        if (sessionStorage.getItem("pageIndex") != undefined) {
          this.pageIndex = sessionStorage.getItem("pageIndex") * 1;
          if (sessionStorage.getItem("detail") == "true") {
            sessionStorage.setItem("detail", false);
          }
          if (sessionStorage.getItem("update") == "true") {
            sessionStorage.setItem("update", false);
          }
        }
      }
      let userId = "";
      try {
        const userStr = localStorage.getItem("user");
        if (userStr) {
          userId = JSON.parse(userStr).userId || "";
        }
      } catch (e) {
        console.error("解析用户信息失败:", e);
      }
      this.deviceData = [];
      this.deviceTotalData = [];
      this.pageIndex = 1;
      let _params = {
        content: this.searchModel.search,
        ejfl: this.searchModel.deviceType,
        pageIndex: this.pageIndex,
        pageSize: this.pagesize,
        sydw: this.searchModel.company,
        userId: userId,
        createTimeStart: this.searchModel.createTimeRange ? this.searchModel.createTimeRange[0] : '',
        createTimeEnd: this.searchModel.createTimeRange ? this.searchModel.createTimeRange[1] : '',
      };
      selectAllDeviceinfo(_params).then((datas) => {
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          // debugger
          if (data.length != 0) {
            this.deviceTotalData = data;
            this.deviceData = data.list;
          }
          // this.deviceData = this.deviceTotalData.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
          this.total = data.total;
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      }).catch((error) => {
        console.error("搜索设备列表失败:", error);
      });
    },
    // 跳转至设备详情页面
    toDetail(data) {
      sessionStorage.setItem("deviceinfoDetail", JSON.stringify(data));
      sessionStorage.setItem("from", "detail");
      sessionStorage.setItem("detail", true);
      sessionStorage.setItem("examineResult", "");

      //添加路由跳转至查看设备
      this.$router.push({
        path: "DeviceDetail",
      });
    },
    // 获取复选框选中数据
    changeCheckBoxValue(val) {
      this.checkBoxData = val;
      this.checkBoxNumber = this.checkBoxData.length;
      // $.each(val,function(i,v){
      //     debugger
      //     this.checkBoxData.push(v);
      // })
    },
    // 清空所有内容
    removeAllCheckbox() {
      this.checkBoxData = [];
      this.checkBoxNumber = this.checkBoxData.length;
      this.$refs.deviceTable.clearSelection(); //清除所有选中复选框
      this.checkBoxdialog = false;
    },
    // 移除一条选中内容
    removeThisData(row) {
      let newCheckBoxData = [];
      for (var i = 0; i < this.checkBoxData.length; i++) {
        if (this.checkBoxData[i].id != row.id) {
          // debugger
          newCheckBoxData.push(this.checkBoxData[i]);
        }
      }
      this.checkBoxData = newCheckBoxData;
      if (this.checkBoxData.length > 0) {
        this.$refs.deviceTable.store.states.selection.map((item, index) => {
          if (item.id === row.id) {
            this.$refs.deviceTable.store.states.selection.splice(index, 1);
          }
        });
      } else {
        this.$refs.deviceTable.clearSelection(); //清除所有选中复选框
        this.checkBoxdialog = false;
      }
      this.checkBoxNumber = this.checkBoxData.length;
    },
    // 点击删除按钮判断是否选中有复选框
    clickDeleteBtn() {
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "至少选择一条数据",
          type: "warning",
        });
      } else {
        // this.dialogDelete=true
        let deleteData = this.checkBoxData.map((item) => item.id).join();
        this.deleteComit(deleteData);
      }
    },
    // 点击编辑按钮
    clickUpdateBtn() {
      if (this.checkBoxData.length != 1) {
        this.$message({
          message: "请选择一条数据",
          type: "warning",
        });
      } else {
        sessionStorage.setItem(
          "deviceUpdate",
          JSON.stringify(this.checkBoxData)
        );
        sessionStorage.setItem("update", true);
        sessionStorage.setItem("examineResult", "other");
        //添加路由跳转至修改设备
        this.$router.push({
          path: "deviceinfoUpdate",
        });
      }
    },
    // 点击删除按钮后调用
    deleteComit(data) {
      this.$confirm("确定删除已选择设备吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let _params = {
          id: data,
          userId: JSON.parse(localStorage.getItem("user")).userId,
        };
        deleteDeviceinfoByid(_params).then((datas) => {
          let { message, status } = datas;
          if (status == 200) {
            this.$message({ message: "删除成功", type: "success" });
            this.removeAllCheckbox();
            this.getDeviceinfo();
          } else {
            this.$message({ message: "删除失败", type: "error" });
          }
        });
      });
    },
    // 格式化一级分类列
    formateYjfl(row, colum) {
      let yjfl = "";
      for (var i = 0; i < this.deviceTypeData.length; i++) {
        if (this.deviceTypeData[i].id.indexOf(row.yjfl) != -1) {
          yjfl = this.deviceTypeData[i].deviceTypeName;
          return yjfl;
        }
      }
    },
    // 格式化二级分类列
    formateEjfl(row, colum) {
      let ejfl = "";
      for (var i = 0; i < this.deviceTypeData.length; i++) {
        if (row.ejfl == this.deviceTypeData[i].id) {
          ejfl = this.deviceTypeData[i].deviceTypeName;
          return ejfl;
        }
      }
    },
    // 格式化专业分类列
    formateZyfl(row, colum) {
      let zyfl = "";
      for (var i = 0; i < this.zyflData.length; i++) {
        if (row.zyfl == this.zyflData[i].id) {
          zyfl = this.zyflData[i].name;
          return zyfl;
        }
      }
    },
    // 格式化项目分类列
    formateXmfl(row, colum) {
      let xmfl = "";
      for (var i = 0; i < this.xmflData.length; i++) {
        if (row.xmfl == this.xmflData[i].id) {
          if (row.zyfl == this.xmflData[i].mId) {
            xmfl = this.xmflData[i].name;
            return xmfl;
          }
        }
      }
    },
    // 跳转至添加页面
    toDeviceinAdd() {
      //添加路由跳转至查看设备
      this.$router.push({
        path: "deviceinfoAdd",
      });
    },
    // 开启loading
    // 数据导出到excel
    export2Excel() {
      let _this = this;
      let ids = "";
      if (this.checkBoxData.length > 0) {
        ids = this.checkBoxData.map((item) => item.id).join();
      }
      this.loadingUtil.showLoading("正在下载中，请稍后……");

      let _params = {
        content: this.searchModel.search,
        ejfl: this.searchModel.deviceType,
        sydw: this.searchModel.company,
        userId: JSON.parse(localStorage.getItem("user")).userId,
        id: ids,
      };
      exportDevice(_params).then((resultData) => {
        const blob = new Blob([resultData]);
        const dlink = document.createElement("a");
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const dlink = document.createElement("a");
          dlink.download = "设备档案信息.xlsx";
          dlink.style.display = "none";
          dlink.href = URL.createObjectURL(blob);
          document.body.appendChild(dlink);
          dlink.click();
          URL.revokeObjectURL(dlink.href); // 释放URL 对象
          document.body.removeChild(dlink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, "设备档案信息.xlsx");
        }
        _this.loadingUtil.hideLoading();
      });
    },
    //导出资产卡片
    exportAssetCard() {
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "至少选择一条数据",
          type: "warning",
        });
        return;
      }
      let _this = this;
      let ids = "";
      if (this.checkBoxData.length > 0) {
        ids = this.checkBoxData.map((item) => item.id).join();
      }
      this.loadingUtil.showLoading("正在下载中，请稍后……");

      let _params = {
        content: this.searchModel.search,
        ejfl: this.searchModel.deviceType,
        sydw: this.searchModel.company,
        userId: JSON.parse(localStorage.getItem("user")).userId,
        id: ids,
      };
      exportAssetCard(_params).then((resultData) => {
        const blob = new Blob([resultData]);
        const dlink = document.createElement("a");
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const dlink = document.createElement("a");
          dlink.download = "资产卡片.docx";
          dlink.style.display = "none";
          dlink.href = URL.createObjectURL(blob);
          document.body.appendChild(dlink);
          dlink.click();
          URL.revokeObjectURL(dlink.href); // 释放URL 对象
          document.body.removeChild(dlink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, "资产卡片.docx");
        }
        _this.loadingUtil.hideLoading();
      });
    },
    //biu~
    selectDeviceCardClick() {
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "请至少选择一台设备",
          type: "warning",
        });
      } else {
        this.deviceDataDetail = this.checkBoxData;
        // console.log(this.deviceDataDetail)
        var jc = [];
        var bg = [];
        this.deviceDataDetail.forEach((item) => {
          if (item.yjfl == "P0001") {
            bg.push(item);
          }
          if (item.yjfl == "P0002") {
            jc.push(item);
          }
        });
        if (bg.length != 0) {
          this.deviceCarddialogbgPL = true;
          this.showType = "办公设备";
          this.$nextTick(() => this.$refs.selectBanGongCard.setTableData());
        }
        if (jc.length != 0) {
          this.deviceCarddialogPL = true;
          this.showType = "检测设备";
          this.$nextTick(() => this.$refs.selectJianceCard.setTableData());
        }
      }
    },

    // 点击设备卡片按钮
    deviceCardClick() {
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "请选择一台设备",
          type: "warning",
        });
      } else if (this.checkBoxData.length > 1) {
        this.$message({
          message: "最多只能选择一台设备",
          type: "warning",
        });
      } else {
        this.deviceDataDetail = this.checkBoxData[0];
        if (this.checkBoxData[0].yjfl.indexOf("P0001") != -1) {
          this.deviceCarddialogbg = true;
          this.showType = "办公设备";
          // this.$nextTick(() =>
          this.$refs.banGongCard.setTableData();
          // )
        } else {
          this.deviceCarddialog = true;
          this.showType = "检测设备";
          // this.$nextTick(() =>
          this.$refs.jianceCard.setTableData();
          // )
        }
      }
    },
    // 导出设备卡片
    deviceCardsClick() {
      this.exportIds = this.checkBoxData.map((item) => item.id).join(",");
      this.showCards = true;
    },
    // 点击资产卡片按钮
    assetCardClick() {
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "请选择一台设备",
          type: "warning",
        });
      } else if (this.checkBoxData.length > 1) {
        this.$message({
          message: "最多只能选择一台设备",
          type: "warning",
        });
      } else {
        let that = this;
        let deviceData = [];
        deviceData = this.checkBoxData[0];
        delete deviceData.aqjdUrls;
        assetCard(deviceData).then((datas) => {
          let blob = new Blob([datas], { type: "docx" });
          docxPre.renderAsync(blob, that.$refs.docxView);
        });
        this.assetCardDialog = true;
      }
    },
    // 下载资产卡片
    downloadAssetCard() {
      let deviceData = [];

      deviceData = this.checkBoxData[0];
      // assetCard(deviceData).then(datas => {
      //     let blob = new Blob([datas], { type: "docx" })

      // })
      assetCard(deviceData).then((resultData) => {
        const blob = new Blob([resultData]);
        const dlink = document.createElement("a");
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const dlink = document.createElement("a");
          dlink.download = this.checkBoxData[0].zcmc + "-资产卡片.docx";
          dlink.style.display = "none";
          dlink.href = URL.createObjectURL(blob);
          document.body.appendChild(dlink);
          dlink.click();
          URL.revokeObjectURL(dlink.href); // 释放URL 对象
          document.body.removeChild(dlink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(
            blob,
            this.checkBoxData[0].zcmc + "-资产卡片.docx"
          );
        }
        // _this.loadingUtil.hideLoading()
      });
    },
    // 点击申请维保
    clickWeiBao() {
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "至少选择一条数据",
          type: "warning",
        });
      } else {
        this.dialogTitle = "申请维保";
        this.dialogShow = true;
        this.showType = "维保";
      }
    },
    // 点击申请报废
    clickBaoFei() {
      // this.$router.push({
      //     path: "scrap",
      // });
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "至少选择一条数据",
          type: "warning",
        });
      } else {
        this.dialogTitle = "申请报废";
        this.dialogShow = true;
        this.showType = "报废";
      }
    },
    // 点击检定录入
    clickCheck() {
      this.$router.push({
        path: "verification",
      });
      // if (this.checkBoxData.length <= 0) {
      //     this.$message({
      //         message: "至少选择一条数据",
      //         type: 'warning'
      //     });
      // } else {
      //     this.dialogTitle = "检定录入"
      //     this.dialogShow = true
      //     this.showType = "检定录入"
      // }
    },
    // 点击资产调拨
    clickDiaoBo() {
      this.$router.push({
        path: "allocation",
      });
    },
    // 点击调入确认
    clickDiaoBoQuer() {
      this.$router.push({
        path: "confirmin",
      });
    },
    //划入设备超市
    transferToMarketHandle() {
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "至少选择一条数据",
          type: "warning",
        });
        return;
      }
      if (this.checkBoxData.length > 1) {
        this.$message({
          message: "只能选择一条数据",
          type: "warning",
        });
        return;
      }
      if (this.checkBoxData[0].isMarket == "1") {
        this.$message({
          message: "该设备已在设备超市",
          type: "warning",
        });
        return;
      }
      this.toMarketShow = true;
      //加载附件
      let _params = {};
      _params.deviceId = this.checkBoxData[0].id;
      selectAnnex(_params).then((datas) => {
        let { status, data } = datas;
        this.annexList = data;
      });
    },
    transferToMarketOk() {
      this.$refs.toMarketForm.validate((valid) => {
        if (valid) {
          // 保存保管人历史记录
          this.savePersonHistory(this.toMarketForm.personName);

          let _params = {
            id: this.checkBoxData.map((item) => item.id).join(),
            ...this.toMarketForm,
          };
          transferToMarket(_params).then((datas) => {
            let { status, message } = datas;
            if (status == 200) {
              this.toMarketForm = {};
              this.$message({
                message: message,
                type: "success",
              });
              this.removeAllCheckbox();
              this.getDeviceinfo();
              this.toMarketShow = false;
            } else {
              this.$message({
                message: message,
                type: "error",
              });
            }
          });
        } else {
        }
      });
    },
    // 点击启用或停用按钮
    clickStartOrStop(actionType) {
      let action = actionType === "start" ? "启用" : "停用";
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "至少选择一条数据",
          type: "warning",
        });
      } else {
        this.$confirm("确定" + action + "已选择设备吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          let deleteData = this.checkBoxData.map((item) => item.id).join();
          let _params = {
            actionType: actionType,
            id: deleteData,
          };
          startOrStop(_params).then((datas) => {
            let { status, message } = datas;
            if (status == 200) {
              this.$message({
                message: message,
                type: "success",
              });
              this.removeAllCheckbox();
              this.getDeviceinfo();
            } else {
              this.$message({
                message: message,
                type: "error",
              });
            }
          });
        });
      }
    },
    // 点击可调拨或在用按钮
    clickDiaoBoOrUsed(actionType) {
      let action = actionType === "used" ? "在用" : "可调拨";
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "至少选择一条数据",
          type: "warning",
        });
      } else {
        this.$confirm("确定将已选择设备设置为" + action + "吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          let deviceId = this.checkBoxData.map((item) => item.id).join();
          debugger;
          let _params = {
            actionType: actionType,
            id: deviceId,
          };
          usedOrDiaoBo(_params).then((datas) => {
            let { status, message } = datas;
            if (status == 200) {
              this.$message({
                message: message,
                type: "success",
              });
              this.removeAllCheckbox();
              this.getDeviceinfo();
            } else {
              this.$message({
                message: message,
                type: "error",
              });
            }
          });
        });
      }
    },
    // switch开关改变事件
    switchChange(val, row) {
      let actionType = val === true ? "used" : "diaoBo";
      // let deviceId = this.checkBoxData.map(item => item.id).join()
      let _params = {
        actionType: actionType,
        id: row.id,
      };
      // usedOrDiaoBo(_params).then(datas=>{
      //     let {status,message}=datas
      //     if(status==200){
      //         this.$message({
      //             message: message,
      //             type: 'success'
      //         });
      //     }else{
      //         this.$message({
      //             message: message,
      //             type: 'error'
      //         });
      //     }
      // })
    },
    // 格式化使用年限
    formateUseTime(row) {
      let buyDate = new Date(row.cgrq);
      let nowDate = new Date();
      let userTime = nowDate.getTime() - buyDate.getTime();
      let useYear = userTime / 1000 / 60 / 60 / 24 / 365;
      if (useYear < 1) {
        return 1;
      } else {
        if (!isNaN(useYear)) {
          return Math.floor(useYear);
        }
      }
      // let year = nowData.getFullYear();
      // let month = (nowData.getMonth() + 1).toString().padStart(2, '0');
      // let date = nowData.getDate().toString().padStart(2, '0');
      // return `${year}-${month}-${date}`;
    },
    // 定义方法关闭dialog对话框
    isShow() {
      this.dialogShow = false;
    },
    // 点击设备卡片

    // 监听对话框关闭，清除里面的数据
    closeDialog() {
      if (this.showType == "维保") {
        this.$refs.weibaoApply.questionForm.reason = "";
        this.$refs.weibaoApply.questionForm.maintenanceType = "";
        this.removeAllCheckbox();
      }
      if (this.showType == "报废") {
        this.$refs.baoFeiApply.questionForm.reason = "";
        this.removeAllCheckbox();
      }
      // if (this.showType == '检测设备') {
      //     debugger
      //     this.$refs.jianceCard.deviceinfoData = []
      //     this.$refs.jianceCard.deviceinfoData.push({
      //         prop1: "设备管理卡片"
      //     }, {
      //         prop1: "资产名称",
      //         prop2: ""
      //     }, {
      //         prop1: "设备型号",
      //         prop2: "",
      //         prop3: "",
      //     }, {
      //         prop1: "生产厂家",
      //         prop2: ""
      //     }, {
      //         prop1: "出厂编号",
      //         prop2: ""
      //     }, {
      //         prop1: "规格型号",
      //         prop2: ""
      //     }, {
      //         prop1: "购置日期",
      //         prop2: ""
      //     }, {
      //         prop1: "所属部门",
      //         prop2: "",
      //         prop3: "保管人",
      //         prop4: "",
      //     })
      // }
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleChange(file, fileList) {
      this.file = file;
      this.fileList = fileList;
      this.uploadBool = false;
      this.fileTemp = file.raw;
      let reader = new FileReader();

      // 判断上传文件格式
      if (this.fileTemp) {
        // if ((this.fileTemp.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') || (this.fileTemp.type == 'application/vnd.ms-excel')) {
        this.importfxx(this.fileTemp);
        // } else {
        //     this.$message({
        //         type: 'warning',
        //         message: '附件格式错误，请删除后重新上传！'
        //     })
        // }
      }
    },
    uploadFile(file) {
      // this.insertFormData.append("file", file.file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    beforeUpload(file) {
      // const isPdf = file.type === 'application/pdf';
      // if (!isPdf) {
      // 	this.$message.error('仅支持 pdf 格式!');
      // }
      // return isPdf
      this.uploadBool = true;
    },
    download() {
      window.open(getBase() + '/deviceinfo/downloadTemplateFile?fileName=deviceinfo.xlsx');
    },
    closeExcelDialog() {
      this.fileList = [];
    },
    importfxx(obj) {
      let _this = this;
      // 通过DOM取文件数据
      this.file = obj;
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;
      var reader = new FileReader();
      FileReader.prototype.readAsBinaryString = function (f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var wb; //读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);
          console.log(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              //手动转化
              type: "base64",
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary",
            });
          }
          const worksheet = wb.Sheets[wb.SheetNames[0]];
          outdata = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); //outdata就是读取excel内容之后输出的东西
          this.da = [...outdata];
          let arr = [];
          let arrlist = [];
          _this.deviceinfoList = [];
          this.da.map((v, index) => {
            if (index > 1) {
              arr = [];
              // if(v[1]==null){
              //     return
              // }else{\
              for (var i = 0; i < outdata[1].length; i++) {
                if (v.length > 0) {
                  arr.push(v[i] != null ? v[i] : "");
                } else {
                  return;
                }
              }
              // }
              _this.deviceinfoList.push(arr);
            }
          });
          // _this.deviceinfoList=arrlist
          console.log(_this.deviceinfoList);
          //return arr
          // 把读取的excel表格中的内容放进tableData2中(这里要改成自己的表的名字)
          // _this.tableData2 = _this.tableData2.concat(arr)
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },
    clickUpload() {
      if (this.fileList.length == 0) {
        this.$message({
          message: "请选择文件",
          type: "warning",
        });
      } else if (this.deviceinfoList.length == 0) {
        this.$message({
          message: "请勿上传空文件",
          type: "warning",
        });
      } else {
        let companyNames = [];
        let deviceTypeNames = [];
        let projectTypeNames = [];
        let deviceStatus = [];
        let isTrue = true;
        for (var j = 0; j < this.companyData.length; j++) {
          companyNames.push(this.companyData[j].companyName);
        }
        for (var i = 0; i < this.deviceTypeData.length; i++) {
          deviceTypeNames.push(this.deviceTypeData[i].deviceTypeName);
        }
        for (var i = 0; i < this.xmflData.length; i++) {
          projectTypeNames.push(this.xmflData[i].name);
        }
        for (var i = 0; i < this.deviceStatuData.length; i++) {
          deviceStatus.push(this.deviceStatuData[i].statusName);
        }
        // console.log("companyNames",companyNames)
        for (var i = 0; i < this.deviceinfoList.length; i++) {
          if (
            this.deviceinfoList[i][1] == null ||
            this.deviceinfoList[i][1].length < 0 ||
            this.deviceinfoList[i][1] == "" ||
            this.deviceinfoList[i][4] == null ||
            this.deviceinfoList[i][4].length < 0 ||
            this.deviceinfoList[i][4] == "" ||
            this.deviceinfoList[i][5] == null ||
            this.deviceinfoList[i][5].length < 0 ||
            this.deviceinfoList[i][5] == "" ||
            this.deviceinfoList[i][6] == null ||
            this.deviceinfoList[i][6].length < 0 ||
            this.deviceinfoList[i][6] == "" ||
            this.deviceinfoList[i][7] == null ||
            this.deviceinfoList[i][7].length < 0 ||
            this.deviceinfoList[i][7] == "" ||
            this.deviceinfoList[i][8] == null ||
            this.deviceinfoList[i][8].length < 0 ||
            this.deviceinfoList[i][8] == "" ||
            this.deviceinfoList[i][9] == null ||
            this.deviceinfoList[i][9].length < 0 ||
            this.deviceinfoList[i][9] == "" ||
            this.deviceinfoList[i][10] == null ||
            this.deviceinfoList[i][10].length < 0 ||
            this.deviceinfoList[i][10] == "" ||
            this.deviceinfoList[i][11] == null ||
            this.deviceinfoList[i][11].length < 0 ||
            this.deviceinfoList[i][11] == "" ||
            this.deviceinfoList[i][12] == null ||
            this.deviceinfoList[i][12].length < 0 ||
            this.deviceinfoList[i][12] == "" ||
            this.deviceinfoList[i][16] == null ||
            this.deviceinfoList[i][16].length < 0 ||
            this.deviceinfoList[i][16] == "" ||
            this.deviceinfoList[i][17] == null ||
            this.deviceinfoList[i][17].length < 0 ||
            this.deviceinfoList[i][17] == ""
          ) {
            isTrue = false;
            this.$message({
              message: "文件第" + (i + 3) + "行必填项空缺，请填写后再导入",
              type: "warning",
            });
            return;
          } else {
            isTrue = true;
          }
        }
        if (isTrue) {
          this.excelLoadingText = "上传中……";
          this.loading = true;
          this.loadingUtil.showLoading("正在上传中，请稍后……");
          let deviceinfos = [];
          for (var i = 0; i < this.deviceinfoList.length; i++) {
            deviceinfos.push({
              zcmc: this.deviceinfoList[i][1],
              zcbh: this.deviceinfoList[i][2],
              glbh: this.deviceinfoList[i][3],
              sbxh: this.deviceinfoList[i][4],
              sccj: this.deviceinfoList[i][5],
              ccbh: this.deviceinfoList[i][6],
              sydw: this.formateExcelSydw(this.deviceinfoList[i][7]),
              ss: this.deviceinfoList[i][7],
              bgr: this.deviceinfoList[i][8],
              cgrq: this.formateExceldate(this.deviceinfoList[i][9]),
              clfw: this.deviceinfoList[i][10],
              cljd: this.deviceinfoList[i][11],
              yjfl: this.formateExcelyjfl(this.deviceinfoList[i][12]),
              zyfl: this.formateExcelzyfl(this.deviceinfoList[i][13]),
              xmfl: this.formateExcelxmfl(this.deviceinfoList[i][14]),
              ejfl: this.formateExcelejfl(this.deviceinfoList[i][15]),
              jdlx: this.formateExcelJdlx(this.deviceinfoList[i][16]),
              jdzq: this.deviceinfoList[i][17],
              sl: this.deviceinfoList[i][18],
              dw: this.deviceinfoList[i][19],
              ccrq: this.formateExceldate(this.deviceinfoList[i][20]),
              syr: this.deviceinfoList[i][21],
              qyrq: this.formateExceldate(this.deviceinfoList[i][22]),
              glfs: this.deviceinfoList[i][23],
              cfdd: this.deviceinfoList[i][24],
              lrr: this.deviceinfoList[i][25],
              sbzt: this.formateExcelSbzt(this.deviceinfoList[i][26]),
              dbzt: this.formateExcelDbzt(this.deviceinfoList[i][27]),
              bz: this.deviceinfoList[i][28],
            });
          }
          // console.log(deviceinfos)
          let _params = {
            parameter: JSON.stringify(deviceinfos),
            userId: JSON.parse(localStorage.getItem("user")).userId,
          };
          insertDevices(_params).then((resultData) => {
            let { data, message, status } = resultData;
            if (status == 200) {
              isTrue = false;
              this.loadingUtil.hideLoading();
              this.deviceinfoList = [];
              this.importExcelDialog = false;
              this.fileList = [];
              this.$message({
                message: "导入成功",
                type: "success",
              });
              this.getDeviceinfo();
              this.excelLoading = false;
              this.excelLoadingText = "立即上传";
            } else if (status == 400) {
              this.$message({
                message: message,
                type: "warning",
              });
              this.excelLoading = false;
              this.excelLoadingText = "立即上传";
              this.loadingUtil.hideLoading();
            } else {
              this.$message({
                message: message,
                type: "error",
              });
              this.excelLoading = false;
              this.excelLoadingText = "立即上传";
              this.loadingUtil.hideLoading();
            }
          });
        }
      }
    },
    //格式化使用单位
    formateExcelSydw(companyName) {
      let companyCode = "";
      for (var i = 0; i < this.companyData.length; i++) {
        if (companyName != null && companyName != "") {
          if (this.companyData[i].companyName == companyName) {
            companyCode = this.companyData[i].companyCode;
          }
        }
      }
      return companyCode;
    },
    // 格式化启用日期
    formateExceldate(dates) {
      let date1 = "";
      const newDate = dates;

      if (newDate != null && newDate != "") {
        if (typeof newDate == "string") {
          let dt = new Date(newDate);
          date1 =
            dt.getFullYear() +
            "-" +
            (dt.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt.getDate().toString().padStart(2, "0");
        } else {
          let dt = new Date((newDate - 25569) * 24 * 60 * 60 * 1000);
          let year = dt.getFullYear();
          let month = (dt.getMonth() + 1).toString().padStart(2, "0");
          let date = dt.getDate().toString().padStart(2, "0");
          let hour = dt.getHours().toString().padStart(2, "0");
          let minute = dt.getMinutes().toString().padStart(2, "0");
          let second = dt.getSeconds().toString().padStart(2, "0");
          date1 =
            dt.getFullYear() +
            "-" +
            (dt.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt.getDate().toString().padStart(2, "0");
        }
      }
      return date1;
    },
    // 格式化设备类型
    formateExcelyjfl(yjflName) {
      let yjfl = "";
      if (yjflName != null && yjflName != "" && yjflName != "/") {
        for (var i = 0; i < this.deviceTypeData.length; i++) {
          if (yjflName == this.deviceTypeData[i].deviceTypeName) {
            this.yjid = this.deviceTypeData[i].id;
            yjfl = this.deviceTypeData[i].id;
          }
        }
      } else {
        yjfl = yjflName;
      }
      return yjfl;
    },
    // 格式化项目分类
    formateExcelxmfl(xmflName) {
      let xmfl = "";
      if (xmflName == "无项目") {
        xmfl = "/";
      }
      if (xmflName != null && xmflName != "" && xmflName != "/") {
        for (var i = 0; i < this.deviceTypeData.length; i++) {
          if (
            xmflName == this.deviceTypeData[i].deviceTypeName &&
            this.deviceTypeData[i].level == 3 &&
            this.deviceTypeData[i].pid == this.zyid
          ) {
            this.xmid = this.deviceTypeData[i].id;
            xmfl = this.deviceTypeData[i].code;
          }
        }
      } else {
        xmfl = xmflName;
      }
      return xmfl;
    },
    // 格式化专业分类
    formateExcelzyfl(zyflName) {
      let zyfl = "";
      if (zyflName == "无专业") {
        zyfl = "/";
      }
      if (zyflName != null && zyflName != "" && zyflName != "/") {
        for (var i = 0; i < this.deviceTypeData.length; i++) {
          if (
            zyflName == this.deviceTypeData[i].deviceTypeName &&
            this.deviceTypeData[i].level == 2
          ) {
            this.zyid = this.deviceTypeData[i].id;
            zyfl = this.deviceTypeData[i].code;
          }
        }
      } else {
        zyfl = zyflName;
      }
      return zyfl;
    },
    // 格式化设备分类
    formateExcelejfl(ejflName) {
      let ejfl = "";
      if (ejflName != null && ejflName != "" && ejflName != "/") {
        if (this.yjid == "P0001") {
          for (var i = 0; i < this.deviceTypeData.length; i++) {
            if (ejflName == this.deviceTypeData[i].deviceTypeName) {
              ejfl = this.deviceTypeData[i].id;
            }
          }
        } else {
          for (var i = 0; i < this.deviceTypeData.length; i++) {
            if (
              ejflName == this.deviceTypeData[i].deviceTypeName &&
              this.deviceTypeData[i].pid == this.xmid
            ) {
              ejfl = this.deviceTypeData[i].id;
            }
          }
        }
      } else {
        ejfl = ejflName;
      }
      return ejfl;
    },
    // 格式化设备状态
    formateExcelSbzt(status) {
      let sbzt = "";
      if (status != null && status != "" && status != "/") {
        for (var i = 0; i < this.deviceStatuData.length; i++) {
          if (status == this.deviceStatuData[i].statusName) {
            sbzt == this.deviceStatuData[i].id;
          }
        }
      }
      return sbzt;
    },
    // 格式化调拨状态
    formateExcelDbzt(status) {
      let dbzt = status == "可调拨" ? 0 : 1;
      return dbzt;
    },
    // 格式化检定类型
    formateExcelJdlx(jdlxs) {
      let jdlx = 0;
      if (jdlxs == "检定") {
        jdlx = 0;
      } else if (jdlxs == "校准") {
        jdlx = 2;
      } else if (jdlxs == "设备核查") {
        jdlx = 1;
      } else if (jdlxs == "不检定/校准") {
        jdlx = 3;
      }
      return jdlx;
    },
  },
  created() {
    this.loadPersonHistory();
    this.selectAllLables();
    this.getCompanyTree();
    this.loadDeviceData();
    this.getfenleiData();
  },
  // keep-alive 缓存后重新激活时，刷新设备列表数据
  activated() {
    this.loadDeviceData();
    // 缓存激活后表格可能未按最新列配置计算宽度，强制重排
    this.$nextTick(() => {
      if (this.$refs.deviceTable) {
        this.$refs.deviceTable.doLayout();
      }
    });
  },
  watch: {
    check(newVal) {
      if (newVal) {
        var arr = this.checkList.filter((i) => newVal.indexOf(i) < 0); //未选中
        this.deviceTable.map((i) => {
          if (arr.indexOf(i.label) !== -1) {
            i.ispass = false;
          } else {
            i.ispass = true;
            this.$nextTick(() => {
              this.$refs.deviceTable.doLayout();
            });
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.btn {
  float: left;
}

.statueBtn {
  padding: 10px 10px;
  border: 0px;
  float: left;
  margin-left: 10px;
}

.statueSpan {
  vertical-align: middle;
  float: left;
  margin-left: 5px;
}

/* .el-input__inner{
    height:40px!important
} */
</style>
<style>
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>
<style lang="less" scoped>
#deviceTable {
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    /*滚动条宽度*/
    height: 15px;
    /*滚动条高度*/
    margin-top: 100px;
  }

  /* 给固定列设置下边距 */
  /deep/ .el-table__fixed {
    height: auto !important;
    bottom: 15px !important;
    /* 具体值是多少根据你横向滚动条的高度进行设置 */
  }

  /deep/ .el-table__fixed-left {
    height: 100% !important;
  }

  /* 去掉固定列下方的横线 */
  /deep/ .el-table__fixed::before,
  .el-table__fixed-left::before {
    display: none;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background: #ededed;
  }

  /*定义滑块 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #cfcbcb;
  }

  /deep/ .el-table__fixed-body-wrapper {
    height: calc(100% -57px) !important;
    padding-bottom: 17px;
    box-sizing: content-box;
  }

  /deep/ .tr-diaobo {
    color: red !important;
  }

  /deep/ .tr-baofei {
    color: #580fda !important;
  }

  /deep/ .tr-jiandin {
    color: #f4de5c !important;
  }
}

.el-table--border {
  border-color: #000000 !important;
  width: 320px;
  border-right: 1px solid #000000 !important;
  border-bottom: 1px solid #000000 !important;
}

#table /deep/ .cell {
  padding-left: 2px !important;
  padding-right: 0px !important;
}

.docx-wrapper {
  background: white !important;
  padding: 10px;
}

.docx {
  padding: 0pt 20.65pt 20pt 20.55pt !important;
  width: 789.9pt !important;
  min-height: 0px !important;
  margin-top: -30px !important;
  margin-left: -10px !important;
}

.annex-list {
  padding: 10px;
}

.annex-list li {
  line-height: 30px;
}

/* 保管人历史记录样式 */
.person-history-item {
  display: flex;
  align-items: center;
  padding: 4px 0;
}

.person-history-item i {
  margin-right: 8px;
  color: #909399;
}

.person-history-item span {
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/views/device/DeviceInfo.vue